import { Injectable } from '@angular/core';
import { OfflineService } from './offline.service';
import { Params } from '@angular/router';
import { EMPTY, from, Observable, of, switchMap } from 'rxjs';
import { ILabelValue } from '../common-dropdawn/typing/label-value.interface';
import { IItem } from '../../typing/item.interface';
import { IPaginatedResponse } from '../../typing/response.interface';

@Injectable({
    providedIn: 'root'
})
export class OfflineEquipmentsService {
    additionalParams: Params = {};

    constructor(private offlineService: OfflineService) {}

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        return from(this.offlineService.getEquipmentList()).pipe(
            switchMap((response) => {
                if (!response) {return EMPTY;}

                let equipmentList = response.data;

                const isParams = Object.keys(this.additionalParams).length;

                if (query['search'].length) {
                    equipmentList = equipmentList.filter((item) =>  {
                        return item.name.toLowerCase().includes(query['search']?.toLowerCase());
                    });
                }

                if (isParams) {
                    const filteredData = equipmentList.filter(item => {
                        return Object.entries(this.additionalParams).every(([key, value]) => {
                            const itemValue = this.getNestedValue(item, key);
                            return itemValue === value;
                        });
                    });
                    /** Фильтрация по параметрам */

                    response.data = filteredData;
                }
                return of(this.transformData(response));
            }),
        );
    }

    private getNestedValue(item: IItem, path: string): unknown {
        let current: unknown = item;
        const keys = path.split('.');

        for (const key of keys) {
            if (current === null || current === undefined || typeof current !== 'object') {
                return null;
            }

            const obj = current as Record<string, unknown>;
            current = obj[key];

            if (current === undefined) {
                return null;
            }
        }

        return current;
    }

    transformData(paginatedResponse: IPaginatedResponse<IItem>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(item => ({
            label: item.name,
            value: item.id,
            tooltip: this.getTooltip(item),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return from(this.offlineService.getEquipmentList()).pipe(
            switchMap((response) => {
                if (!response?.data) {
                    return  EMPTY;
                }

                const equipment = response.data.map((item) => {
                    return {
                        label: item.name as string,
                        value: item.id as number,
                        tooltip: '',
                    };
                }).find((item) => item.value === Number(optionValue));

                if (!equipment) {
                    return  EMPTY;
                }

                return of(equipment);
            })
        );
    }

    getTooltip(value: IItem): string {
        return (value.name ? value.name : '') + (value.id ? '; id:' + value.id : '') ;
    }
}

